import { get } from 'lodash';
import { reach } from 'yup';
export var isFieldRequiredBySchema = (name, schema) => {
  try {
    var _reach, _reach$exclusiveTests;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return !!((_reach = reach(schema, name)) !== null && _reach !== void 0 && (_reach$exclusiveTests = _reach.exclusiveTests) !== null && _reach$exclusiveTests !== void 0 && _reach$exclusiveTests.required);
  } catch (error) {
    //reach throws error when the schema does not contain the path
    return false;
  }
};
export var getFieldError = (name, errors) => get(errors, name);
//# sourceMappingURL=useMelioForm.utils.js.map